import {
  useColorModeValue,
  chakra,
  Button,
  Image,
} from '@chakra-ui/react';
import React from 'react';

import Skeleton from 'ui/shared/chakra/Skeleton';
import IconSvg from 'ui/shared/IconSvg';

interface Props {
  isOpen?: boolean;
  isLoading?: boolean;
  className?: string;
  onClick?: () => void;
  iconSrc?: string;
  iconSize?: string;
  iconColor?: string;
  iconHoverColor?: string;
}

const AdditionalInfoButton = ({
  isOpen,
  onClick,
  className,
  isLoading,
  iconSrc,
  iconSize,
  iconColor,
  iconHoverColor = 'link_hovered',
}: Props, ref: React.ForwardedRef<HTMLButtonElement>) => {

  const infoBgColor = useColorModeValue('blue.50', 'gray.600');
  const resolvedIconSize = iconSize || (iconSrc ? '16px' : '14px');

  if (isLoading) {
    return <Skeleton boxSize={ 6 } borderRadius="sm" flexShrink={ 0 }/>;
  }

  return (
    <Button
      variant="unstyled"
      display="inline-flex"
      alignItems="center"
      className={ className }
      ref={ ref }
      background={ isOpen ? infoBgColor : 'unset' }
      borderRadius="8px"
      w={ resolvedIconSize }
      h={ resolvedIconSize }
      onClick={ onClick }
      cursor="pointer"
      flexShrink={ 0 }
      aria-label="Transaction info"
    >
      { iconSrc ? (
        <Image src={ iconSrc } alt="" boxSize={ resolvedIconSize }/>
      ) : (
        <IconSvg
          name="info"
          boxSize="14px"
          color={ isOpen ? iconHoverColor : (iconColor || 'icon_info') }
          _hover={{ color: iconHoverColor }}
        />
      ) }
    </Button>
  );
};

export default chakra(React.forwardRef(AdditionalInfoButton));
